import { render, staticRenderFns } from "./CompanyCreate.vue?vue&type=template&id=eb47973a&"
import script from "./CompanyCreate.vue?vue&type=script&lang=js&"
export * from "./CompanyCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports